import { HOW_FIVERR_WORKS_VIDEOS } from '../constants';

export const getLocalizedHowFiverrWorksVideo = (locale) => {
    const videoUrl = HOW_FIVERR_WORKS_VIDEOS[locale];
    if (!videoUrl) {
        return HOW_FIVERR_WORKS_VIDEOS.DEFAULT;
    }

    return videoUrl;
};
